import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "back-top"
  }, [_c('div', {
    staticClass: "sidebar-right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isCustomerVisible,
      expression: "isCustomerVisible"
    }],
    staticClass: "icon-shopping",
    attrs: {
      "tag": "div"
    },
    on: {
      "click": _vm.openBrowser
    }
  }, [_vm._m(0)]), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCart,
      expression: "showCart"
    }],
    staticClass: "icon-shopping icon-top icon-center",
    class: {
      active: _vm.isConsumables || !_vm.hasShopping
    },
    attrs: {
      "tag": "div",
      "to": "/card"
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icongouwuchePC"
  }), this.cardstate.cardnumber ? _c('em', [_vm._v(_vm._s(this.cardstate.cardnumber))]) : _vm._e(), _c('b', [_vm._v("购物车")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isConsumables,
      expression: "isConsumables"
    }],
    staticClass: "icon-shopping icon-top icon-center",
    attrs: {
      "tag": "div"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push("consumables-orderlist?currentIndex=0");
      }
    }
  }, [_vm._m(1)]), _vm.isbackTop ? _c('div', {
    staticClass: "icon-top",
    on: {
      "click": _vm.goTop
    }
  }, [_c('i', {
    staticClass: "iconfont icontop"
  }), _c('span', [_vm._v("TOP")])]) : _vm._e(), _c('Im', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showIm,
      expression: "showIm"
    }],
    ref: "imSys",
    staticClass: "im-box",
    on: {
      "passpicker": _vm.passpicker,
      "closeIm": _vm.closeIm
    }
  })], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_c('i', {
    staticClass: "iconfont iconlianxiwomen"
  }), _c('b', [_vm._v("客服")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_c('i', {
    staticClass: "iconfont icondingdanjilu"
  })]);
}];
export { render, staticRenderFns };